export const tooltipAirportTextFormatter = stop =>
  stop.get("country") ? `${stop.get("name")} ${stop.get("code")} (${stop.get("country")})` : ""

export const tooltipCountryTextFormatter = (stop, countries) =>
  stop.get("country") ? `${countries.get(stop.get("country").toLowerCase())}` : ""

export const bannerTextFormatter = (stop, countries) =>
  stop.get("country")
    ? `${countries.get(stop.get("country").toLowerCase())} (${stop.get("name")})`
    : ""
